import * as React from "react";
import ThreadItem from "../threadItem";
import { CountIndicatorBox } from "../styledComponents";
import { FormattedMessage, useIntl } from "react-intl";
import { ReplyContainer as ReplyContainerStyle } from "../threadReply/styledComponents";
import styled from "styled-components";
import { px2rem } from "common/helpers/rem";
import ThreadInput from "common/components/thread/components/threadInput";

const ReplyContainer = styled(ReplyContainerStyle)`
  padding-bottom: ${px2rem(8)};
  ${CountIndicatorBox} {
    margin-top: ${px2rem(-8)};
  }
`;

const ThreadPreviewWrapper = styled.div<{ openInput: boolean }>`
  background-color: ${({ openInput, theme }) =>
    openInput ? theme.grey100 : theme.white100};
  padding: ${({ openInput }) => openInput && `${px2rem(8)} 0`};
`;

interface IProps {
  threadId: Vingle.ThreadId;
  threads: ReadonlyArray<Vingle.IThread>;
  threadsCount: number;
  targetReplyAuthor: Vingle.User.ISimplifiedUser | null;
  onLoadMoreData: () => void;
  onLike: (thread: Vingle.IThread) => void;
  onReplyWrite: (thread: Vingle.IThread) => void;
  handleCheckUser: () => boolean;
  onAddThread: (
    content: string,
    media?: Vingle.MediaUpload.IUploadInput,
    linkData?: Vingle.LinkUploadData | null,
  ) => void;
  handleHighlightUser?: (comment: Vingle.IThread) => boolean;
  placeholder?: string;
  disableUpload?: boolean;
  disableLink?: boolean;
  targetUser?: Vingle.User.ISimplifiedUser | null;
}

const ThreadPreview = React.memo(
  ({
    threadId,
    threads,
    threadsCount,
    onLike,
    onLoadMoreData,
    onReplyWrite,
    targetReplyAuthor,
    onAddThread,
    disableUpload,
    disableLink,
    handleCheckUser,
    handleHighlightUser,
  }: IProps) => {
    const intl = useIntl();
    const disableEngage = threads.length > 1 && !targetReplyAuthor;
    const handleWrapperClick = React.useCallback(() => {
      if (disableEngage) {
        onLoadMoreData();
      }
    }, [disableEngage]);
    const handleLoadMoreData = React.useCallback((e: React.MouseEvent) => {
      e.stopPropagation();
      onLoadMoreData();
    }, []);
    return (
      <ThreadPreviewWrapper openInput={Boolean(targetReplyAuthor)}>
        <div onClick={handleWrapperClick}>
          {threads.length || threadsCount > 1 ? (
            <ReplyContainer>
              {threadsCount > 1 ? (
                <CountIndicatorBox onClick={handleLoadMoreData}>
                  <FormattedMessage
                    id="see_more_replies"
                    values={{
                      replyCount: threadsCount,
                    }}
                  />
                </CountIndicatorBox>
              ) : null}
              {threads.map(thread => (
                <ThreadItem
                  key={`previewComment__${thread.id}`}
                  parentId={threadId}
                  thread={thread}
                  onLike={onLike}
                  isReply={true}
                  isPreview={true}
                  disableEngage={disableEngage}
                  onReplyWrite={onReplyWrite}
                  handleHighlightUser={handleHighlightUser}
                />
              ))}
            </ReplyContainer>
          ) : null}
        </div>

        {targetReplyAuthor && (
          <ThreadInput
            id={threadId}
            onAddThread={onAddThread}
            onInteraction={handleCheckUser}
            placeholder={intl.formatMessage({ id: "add_a_reply" })}
            inputId={`replyCommentInput${threadId}`}
            autoFocus={Boolean(targetReplyAuthor)}
            disableUpload={disableUpload}
            disableLink={disableLink}
            targetUser={targetReplyAuthor}
          />
        )}
      </ThreadPreviewWrapper>
    );
  },
);

export default ThreadPreview;
